import PropTypes from 'prop-types';
import { useContext } from 'react';
import { Navigate } from 'react-router-dom';

import { AuthContext } from 'src/auth/context/authContext';
import { LoadingScreen } from 'src/components/loading-screen';
import { paths } from 'src/routes/paths';

export default function UserGuard({ children }) {
  const { loading, admin, isAdminAuthenticated } = useContext(AuthContext);

  if (loading) {
    return <LoadingScreen />;
  }

  // 🚫 Admin session should not enter client routes
  if (isAdminAuthenticated || admin) {
    return <Navigate to={paths.admin.root} replace />;
  }

  // ✅ Allow unauthenticated users to render the page.
  // The page itself will show <TransactionsProtectedView />.
  return children;
}

UserGuard.propTypes = {
  children: PropTypes.node,
};
